<template>
	<Dialog
		:value="value"
		:hide-footer="!canBeUpdated || currentTab != 'general'"
		@close="close()"
		@ok="submit($event)"
	>
		<template v-slot:modal-title>
			<Header/>
		</template>
		<b-overlay :show="loading || loadingReservation" no-wrap rounded></b-overlay>
		<CreatedInfo
			:modelId="modelId"
			:copyFromId="copyFromId"
			class="mb-2"
			@onCopyRes="$emit('onCopyRes', $event)"
		/>

		<TabsContainer @activate-tab="activeIndex">
			<!-- General -->
			<b-tab title="General" active>
				<form action="#" @submit.prevent="onSubmit" ref="resForm">
					<TabGeneral
						:tsSelectedId="tsSelectedId"
						:modelId="modelId"
						:canBeUpdated="canBeUpdated"
						:copyFromId="copyFromId"
					/>
				</form>
			</b-tab>
			<!-- /General -->

			<!-- Costos -->
			<b-tab :title="$t('bookings.costs')" v-if="viewModel.id > 0">
				<TabPrices :model-id="viewModel.id" v-if="loadedIndex.includes(1)"/>
			</b-tab>
			<!-- /Costos -->

			<!-- Payments -->
			<b-tab v-if="viewModel.id > 0" :title="$t('payments.payments')">
				<TabPayments :model-id="viewModel.id" v-if="loadedIndex.includes(2)"/>
			</b-tab>
			<!-- /Payments -->

			<!-- Notifications -->
			<b-tab v-if="viewModel.id > 0" :title="$t('bookings.notifications')">
				<TabNotifications v-if="loadedIndex.includes(3)"/>
			</b-tab>
			<!-- /Notifications -->
		</TabsContainer>
	</Dialog>
</template>

<script>
import Dialog from "./helpers/_dialog";
import Header from "./helpers/_header";
import CreatedInfo from "./helpers/_createdInfo.vue";
import TabsContainer from "@/components/helpers/TabsContainer";
import {mapActions, mapState} from "vuex";
import api from "@/api.js";
import TabGeneral from "./tabs/TabGeneral";
import TabPrices from "./tabs/TabPrices";
import TabPayments from "./tabs/TabPayments";
import TabNotifications from "./tabs/TabNotifications";

export default {
	components: {
		TabsContainer,
		Dialog,
		Header,
		CreatedInfo,
		TabGeneral,
		TabPrices,
		TabPayments,
		TabNotifications,
	},
	props: {
		value: Boolean,
		tsSelectedId: {
			type: Number,
			required: false,
			default: -1
		},
		modelId: {
			type: Number,
			required: false,
			default: -1
		},
		copyFromId: {
			type: Number,
			required: false,
			default: -1
		}
	},
	data() {
		return {
			loading: false,
			transportServiceValidStatus: ["active", "pending"],
			currentTab: "general",
			loadedIndex: []
		};
	},

	computed: {
		...mapState("reservation", ["viewModel", "loadingReservation"]),
		canBeUpdated() {
			return (
				this.viewModel.status === "active" &&
				this.viewModel.transportServices.filter(ts =>
					this.transportServiceValidStatus.includes(ts.status)
				).length > 0
			);
		},
	},
	methods: {
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),
		onSubmit() {
			this.loading = true;
			if (this.modelId > 0) {
				// actualizar
				api(this)
					.put(`/reservations/${this.viewModel.id}`, this.viewModel)
					.then((res) => {
						if(res.data.warning) {
							this.$root.showAlert(this.$t('warnings.offlinePOS'), {variant: 'warning'});
							return
						}
						
						this.loading = false;
						this.$root.showAlert(this.$t('global.successUpdate'));
						this.$root.$emit(
							"bv::refresh::table",
							"reservations-index-list"
						);
						this._fetchModel({
							context: this,
							modelId: this.modelId,
							copyFromId: this.copyFromId
						});
						this.fetchNotes()
					})
					.catch(this.$root.handleRequestError);
			} else {
				api(this)
					.post(`/reservations`, this.viewModel)
					.then(res => {
						if(res.data.warning) {
							this.$root.showAlert(this.$t('warnings.offlinePOS'), {variant: 'warning'});
							return
						}
						
						this.loading = false;
						this.$root.showAlert(this.$t('bookings.successNewReservation'));
						this.$root.$emit(
							"bv::refresh::table",
							"reservations-index-list"
						);
						this.$emit("changeId", res.data.id);
					})
					.catch(this.$root.handleRequestError);
			}
			this.loading = false;
		},
		activeIndex(newIndex) {
			return !this.loadedIndex.includes(newIndex)
				? this.loadedIndex.push(newIndex)
				: false;
		},
		submit(event) {
			event.preventDefault();
			if (this.$refs.resForm.checkValidity()) return this.onSubmit();
			this.$refs.resForm.reportValidity();
		},
		close() {
			this.loadedIndex = []
			this.$emit("input", false);
		},
		async fetchNotes() {
			await this._fetchNotes({context: this, modelId: this.modelId});
		}
	}
};
</script>

<style>
@media (max-width: 600px) {
	.box-btns {
		display: block !important;
	}

	.box-btns button {
		margin-top: 5px;
		width: 100% !important;
	}
}

.vbst-item {
	line-height: normal;
}

.list-group-item {
	padding: 0.2rem 0.8rem;
}

.list-group {
	padding-top: 2px;
}

.vue__time-picker input.display-time {
	height: 1.95em;
}

input.display-time.all-selected.disabled {
	background-color: #e9ecef;
	color: #495057;
}

.border-success {
	border-color: #28a745 !important;
}

.border-danger {
	border-color: #dc3545 !important;
}

.border-warning {
	border-color: #ffc107 !important;
}
</style>
